import { serverContextFieldsFormatter } from 'src/context';
import { frameworkIdentifierFormatter } from 'src/identifier';

export const nextJsFormatters = [frameworkIdentifierFormatter, serverContextFieldsFormatter];
